"use strict";
// CSP-safe fallback for images without inline event handlers.
const applyImgFallback = (img) => {
  if (!(img instanceof HTMLImageElement)) return;
  const fallback = img.dataset.fallbackSrc;
  if (!fallback) return;
  if (img.getAttribute("src") === fallback) return;
  img.setAttribute("src", fallback);
};

document.addEventListener("DOMContentLoaded", () => {
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  // Handle failed images (and ones that already failed before JS runs)
  $$('img[data-fallback-src]').forEach((img) => {
    img.addEventListener('error', () => applyImgFallback(img));
    if (img.complete && img.naturalWidth === 0) {
      applyImgFallback(img);
    }
  });
  const toggle = (el, cls, force) => el?.classList.toggle(cls, force);
  const show = (el) => {
    if (!el) return;
    el.classList.remove("hidden");
    const showClass = el.dataset?.showClass;
    if (showClass) showClass.split(" ").forEach((cls) => el.classList.add(cls));
  };
  const hide = (el) => {
    if (!el) return;
    const showClass = el.dataset?.showClass;
    if (showClass) showClass.split(" ").forEach((cls) => el.classList.remove(cls));
    el.classList.add("hidden");
  };
  let mobileMenuOpen = false;
  const mobileMenuButton = $("#mobile-menu-btn");
  const setMobileMenu = (open) => {
    mobileMenuOpen = open;
    const mobileMenu = $("#mobile-menu");
    const menuIcon = $("#menu-icon");
    const closeIcon = $("#close-icon");
    const stickyMobileCta2 = $("#sticky-mobile-cta");
    toggle(mobileMenu, "hidden", !mobileMenuOpen);
    toggle(mobileMenu, "flex", mobileMenuOpen);
    toggle(menuIcon, "hidden", mobileMenuOpen);
    toggle(closeIcon, "hidden", !mobileMenuOpen);
    mobileMenuButton?.setAttribute("aria-expanded", String(mobileMenuOpen));
    mobileMenuButton?.setAttribute("aria-label", mobileMenuOpen ? "Sluit menu" : "Open menu");
    document.body.style.overflow = mobileMenuOpen ? "hidden" : "";
    if (stickyMobileCta2) {
      toggle(stickyMobileCta2, "translate-y-full", mobileMenuOpen);
      toggle(stickyMobileCta2, "pointer-events-none", mobileMenuOpen);
    }
    if (mobileMenuOpen && globalThis.lucide) lucide.createIcons();
  };
  mobileMenuButton?.addEventListener("click", () => setMobileMenu(!mobileMenuOpen));
  $("#mobile-menu")?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setMobileMenu(false));
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && mobileMenuOpen) {
      setMobileMenu(false);
      mobileMenuButton?.focus();
    }
  });
  const header = $("header");
  const stickyMobileCta = $("#sticky-mobile-cta");
  if (header) {
    window.addEventListener("scroll", () => {
      const scrollY = window.scrollY;
      toggle(header, "shadow-md", scrollY > 50);
      if (stickyMobileCta && !mobileMenuOpen) {
        const pastHero = scrollY > 200;
        toggle(stickyMobileCta, "translate-y-full", !pastHero);
        toggle(stickyMobileCta, "pointer-events-none", !pastHero);
      }
    }, { passive: true });
  }
  $$(".before-after-slider").forEach((slider) => {
    const input = $(".before-after-range", slider);
    const overlay = $(".before-after-overlay", slider);
    const handle = $(".before-after-handle", slider);
    if (!input || !overlay || !handle) return;
    const update = (v) => {
      overlay.style.clipPath = `inset(0 ${100 - v}% 0 0)`;
      handle.style.left = `${v}%`;
    };
    input.addEventListener("input", () => update(input.value));
    update(50);
  });
  $$(".faq-trigger").forEach((btn) => {
    btn.addEventListener("click", () => {
      const content = btn.nextElementSibling;
      const icon = btn.querySelector('[data-lucide="chevron-down"], [data-lucide="plus"]');
      const isOpen = !content.classList.contains("hidden");
      const container = btn.closest(".faq-container, .space-y-4, .divide-y");
      if (container) {
        container.querySelectorAll(".faq-content").forEach((c) => {
          if (c !== content) {
            c.classList.add("hidden");
            c.previousElementSibling?.setAttribute("aria-expanded", "false");
            const otherIcon = c.previousElementSibling?.querySelector("[data-lucide]");
            otherIcon?.classList.remove("rotate-180");
          }
        });
      }
      toggle(content, "hidden", isOpen);
      btn.setAttribute("aria-expanded", String(!isOpen));
      toggle(icon, "rotate-180", !isOpen);
    });
  });
  const contactForm = $("#contact-form");
  if (contactForm) {
    const validators = {
      name: { test: (v) => v.trim().length >= 2, msg: "Vul uw naam in" },
      email: { test: (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v), msg: "Vul een geldig e-mailadres in" },
      message: { test: (v) => v.trim().length >= 10, msg: "Uw bericht moet minimaal 10 tekens bevatten" }
    };
    const showError = (input, msg) => {
      const group = input.closest(".form-group") || input.parentElement;
      let errorEl = group.querySelector(".form-error");
      if (!errorEl) {
        errorEl = document.createElement("p");
        errorEl.className = "form-error text-red-500 text-sm mt-1";
        group.appendChild(errorEl);
      }
      errorEl.textContent = msg;
      show(errorEl);
      input.classList.add("border-red-500");
    };
    const clearError = (input) => {
      const group = input.closest(".form-group") || input.parentElement;
      const errorEl = group.querySelector(".form-error");
      if (errorEl) hide(errorEl);
      input.classList.remove("border-red-500");
    };
    contactForm.addEventListener("submit", (e) => {
      let hasError = false;
      for (const [id, v] of Object.entries(validators)) {
        const input = $(`#${id}`, contactForm);
        if (input) {
          if (v.test(input.value)) {
            clearError(input);
          } else {
            showError(input, v.msg);
            hasError = true;
          }
        }
      }
      if (hasError) {
        e.preventDefault();
        contactForm.querySelector(".form-error:not(.hidden)")?.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    });
    Object.keys(validators).forEach((id) => {
      $(`#${id}`, contactForm)?.addEventListener("input", (e) => clearError(e.target));
    });
  }
  $$(".lead-form").forEach((form) => {
    form.addEventListener("submit", (e) => {
      const email = form.querySelector('input[type="email"]');
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
        e.preventDefault();
        email.classList.add("border-red-500");
        email.focus();
      }
    });
  });
  const contactToggleBtn = $("#contact-toggle-btn");
  const contactPopup = $("#contact-options-popup");
  const contactOverlay = $("#contact-overlay");
  const contactToggleIcon = $("#contact-toggle-icon");
  $$('[data-toggle-target]').forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const targetId = trigger.dataset.toggleTarget;
      if (!targetId) return;
      const target = document.getElementById(targetId);
      if (!target) return;
      target.classList.remove("hidden");
      if (trigger.dataset.hideParent === "true") {
        trigger.parentElement?.classList.add("hidden");
      }
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      const firstInput = target.querySelector("input, select, textarea");
      if (firstInput instanceof HTMLElement) {
        setTimeout(() => firstInput.focus(), 250);
      }
      if (globalThis.lucide) lucide.createIcons({ nodes: target.querySelectorAll("[data-lucide]") });
    });
  });
  $$("input[type='tel']").forEach((input) => {
    input.setAttribute("inputmode", "tel");
  });
  const openContactPopup = () => {
    contactPopup?.classList.remove("opacity-0", "translate-y-2", "-z-20", "pointer-events-none");
    contactOverlay?.classList.remove("opacity-0", "pointer-events-none");
    document.body.style.overflow = "hidden";
    if (contactToggleIcon) contactToggleIcon.style.transform = "rotate(180deg)";
  };
  const closeContactPopup = () => {
    contactPopup?.classList.add("opacity-0", "translate-y-2", "-z-20", "pointer-events-none");
    contactOverlay?.classList.add("opacity-0", "pointer-events-none");
    document.body.style.overflow = "";
    if (contactToggleIcon) contactToggleIcon.style.transform = "";
  };
  contactToggleBtn?.addEventListener("click", () => {
    const isOpen = !contactPopup?.classList.contains("opacity-0");
    isOpen ? closeContactPopup() : openContactPopup();
  });
  contactOverlay?.addEventListener("click", closeContactPopup);
  contactPopup?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", closeContactPopup);
  });

  // Mobile accordion for Diensten/Werkgebied
  $$(".mobile-accordion-trigger").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const accordion = trigger.closest(".mobile-accordion");
      const content = accordion?.querySelector(".mobile-accordion-content");
      const icon = accordion?.querySelector(".mobile-accordion-icon");
      const isExpanded = trigger.getAttribute("aria-expanded") === "true";

      // Close other accordions
      $$(".mobile-accordion").forEach((other) => {
        if (other !== accordion) {
          const otherTrigger = other.querySelector(".mobile-accordion-trigger");
          const otherContent = other.querySelector(".mobile-accordion-content");
          const otherIcon = other.querySelector(".mobile-accordion-icon");
          otherTrigger?.setAttribute("aria-expanded", "false");
          otherContent?.classList.add("hidden");
          otherIcon?.classList.remove("rotate-180");
        }
      });

      // Toggle current accordion
      trigger.setAttribute("aria-expanded", String(!isExpanded));
      toggle(content, "hidden", isExpanded);
      toggle(icon, "rotate-180", !isExpanded);
    });
  });
});
